import * as React from 'react';
import clx from 'classnames';
import { Col, Row } from 'antd';
import { ColProps } from 'antd/lib/col';

export interface PageSecondaryColumnProps extends ColProps {
  orderMobile?: number;
  orderDesktop?: number;
  isAdmin?: boolean;
}

/**
 * Colonna principale della pagina frontend con larghezza responsive
 */
export function PageSecondaryColumn(props: PageSecondaryColumnProps) {
  const { orderMobile, orderDesktop, isAdmin, ...othersProps } = props;

  return (
    <Col
      xs={{ span: 24, order: orderMobile ?? 1 }}
      md={{ span: isAdmin ? 9 : 7, offset: 1, order: orderDesktop ?? 2 }}
      lg={{ span: isAdmin ? 8 : 6, offset: 1, order: orderDesktop ?? 2 }}
      {...othersProps}
    />
  );
}
